import { render, staticRenderFns } from "./EnrollTabTransferwisePayment.vue?vue&type=template&id=473e1e22&scoped=true&"
import script from "./EnrollTabTransferwisePayment.vue?vue&type=script&lang=ts&"
export * from "./EnrollTabTransferwisePayment.vue?vue&type=script&lang=ts&"
import style0 from "./EnrollTabTransferwisePayment.vue?vue&type=style&index=0&id=473e1e22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473e1e22",
  null
  
)

export default component.exports